export const documentation = {
  junior: [
    { name: 'API Development Standards', url: '/docs/api-standards', type: 'standards' },
    { name: 'Code Review Guidelines', url: '/docs/code-review', type: 'process' },
    { name: 'Database Schema Guidelines', url: '/docs/database-schema', type: 'database' },
    { name: 'Testing Best Practices', url: '/docs/testing-backend', type: 'testing' },
    { name: 'Git Workflow for Backend', url: '/docs/git-backend', type: 'version-control' }
  ],
  mid: [
    { name: 'System Architecture Guidelines', url: '/docs/system-architecture', type: 'architecture' },
    { name: 'Performance Optimization Guide', url: '/docs/performance-backend', type: 'performance' },
    { name: 'Security Implementation Guide', url: '/docs/security-backend', type: 'security' },
    { name: 'Microservices Design Patterns', url: '/docs/microservices', type: 'architecture' },
    { name: 'API Versioning Strategy', url: '/docs/api-versioning', type: 'api' }
  ],
  senior: [
    { name: 'Technical Leadership Guide', url: '/docs/tech-leadership', type: 'leadership' },
    { name: 'System Design Review Process', url: '/docs/design-review', type: 'process' },
    { name: 'Scalability Planning Guide', url: '/docs/scalability', type: 'architecture' },
    { name: 'Incident Response Procedures', url: '/docs/incident-response', type: 'operations' },
    { name: 'Technology Decision Framework', url: '/docs/tech-decisions', type: 'strategy' }
  ]
};
